import axios from "axios";

export function createMedia(data: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/media';
    return axios({
        method: 'POST',
        url: endpointUrl,
        data: data,
        headers: headers
    });
}

export function getMedia(ids: string) {
    let csr_token = localStorage.getItem('csrf_token');
    csr_token = csr_token ? csr_token : '';
    const headers = {
        'Authorization': 'Basic ZGF2cmVpQGRleGV1cy5jb206ZHIxMDAyNzE=',
        'Content-Type': 'application/json' // ,
        // 'X-CSRF-Token': csr_token
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/rest/dexeus/ciog/v1/files/get?files=' + ids;
    return axios.get(endpointUrl, { headers: headers } );
}

export function getImageBase64(id: string) {
    let csr_token = localStorage.getItem('csrf_token');
    csr_token = csr_token ? csr_token : '';
    const headers = {
        'Authorization': 'Basic ZGF2cmVpQGRleGV1cy5jb206ZHIxMDAyNzE=',
        'Content-Type': 'application/json' // ,
        // 'X-CSRF-Token': csr_token
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/rest/dexeus/ciog/v1/files/get-image-base64/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}
